import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReviewPageBaseComponent } from '../review-page-base/review-page-base.component';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormlyDateSelectionComponent } from '../../../components/formly/formly-date-selection/formly-date-selection.component';
import { FormlyFileSelectionComponent } from '../../../components/formly/formly-file-selection/formly-file-selection.component';
import { getBusinessVisaInformationSection, getCompanyInformationSection, getPassportSection, getPersonalInformationSection, getRegistrationFormHeader, reasonForVisitSection } from '../../../components/forms/base-registration-form/form-field-config';
import { SiteService } from '../../../services/data/site.service';
import { CountryService } from '../../../services/data/country.service';
import { EnumTranslationService } from '../../../services/enum-translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { VisitorRegistrationFormType } from '../../../models/visitor-registration-form-type';

@Component({
    selector: 'app-business-trip-page',
    standalone: true,
    imports: [
        CommonModule,
        FormlyModule,
        TranslateModule,
        ReactiveFormsModule,
        NgbTooltip,
        NgbDatepickerModule,
        TranslateModule,
        FormlyDateSelectionComponent,
        FormlyFileSelectionComponent,
    ],
    templateUrl: './business-trip-page.component.html',
    styleUrl: './business-trip-page.component.scss'
})
export class BusinessTripPageComponent extends ReviewPageBaseComponent {

    constructor(
        _siteService: SiteService,
        _countryService: CountryService,
        _enumTranslationService: EnumTranslationService,
    ) {
        super(VisitorRegistrationFormType.BusinessTrip)

        // Intialize form fields
        this.fields = [
            ...getRegistrationFormHeader(_siteService, _enumTranslationService),
            ...getPersonalInformationSection(_enumTranslationService),
            ...getPassportSection(_countryService),
            ...getBusinessVisaInformationSection(_enumTranslationService),
            ...getCompanyInformationSection(false),
            ...reasonForVisitSection,
        ];
    }
}
